var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46585 8.01284L15.6959 1.78257C16.1014 1.37732 16.1014 0.722079 15.6959 0.316826C15.2907 -0.0884278 14.6354 -0.0884278 14.2302 0.316826L7.99992 6.5471L1.76983 0.316826C1.36438 -0.0884278 0.709334 -0.0884278 0.304081 0.316826C-0.101363 0.722079 -0.101363 1.37732 0.304081 1.78257L6.53417 8.01284L0.304081 14.2431C-0.101363 14.6484 -0.101363 15.3036 0.304081 15.7089C0.506043 15.911 0.771594 16.0126 1.03695 16.0126C1.30231 16.0126 1.56768 15.911 1.76983 15.7089L7.99992 9.47859L14.2302 15.7089C14.4323 15.911 14.6977 16.0126 14.9631 16.0126C15.2284 16.0126 15.4938 15.911 15.6959 15.7089C16.1014 15.3036 16.1014 14.6484 15.6959 14.2431L9.46585 8.01284Z",
    fill: "#264F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ea62cef3.svg";
export { ForwardRef as ReactComponent };